import React, { useState, useEffect, useRef } from 'react';
// SİHİRLİ KOD: Sayfalar arası geçiş yapmak için Link motorunu içeri aldık
import { Link } from 'react-router-dom'; 
// SİHİRLİ KOD: Sayfaya özel Google Tabelası ve JSON Kimlik motoru
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';

import kameraResmi from '../assets/hero-kamera.webp'; 
import fileResmi from '../assets/hero-file.webp';
import ekipmanResmi from '../assets/hero-ekipman.webp';
import akimResmi from '../assets/hero-akim.webp';

import serviceKamera from '../assets/service-kamera.webp';
import serviceFile from '../assets/service-file.webp';
import serviceEkipman from '../assets/service-ekipman.webp';
import serviceAkim from '../assets/service-akim.webp';
import interactiveMapImg from '../assets/interactive-map.webp';
import tanitimVideo from '../assets/tanitim.mp4';

// Slider Listesi
const resimler = [kameraResmi, fileResmi, ekipmanResmi, akimResmi];

// --- İNTERAKTİF NOKTALARIN (HOTSPOTS) VERİSİ ---
const hotspotsData = [
  {
    id: 1,
    top: '30%',    
    left: '30%',
    title: "Yüksekte Çalışma & Düşme Önleyici Fileler",
    desc: "TS EN 1263-1 standartlarında, riskli bölgeleri güvenceye alan mukavemetli güvenlik file ağları.",
    icon: "🕸️"
  },
  {
    id: 2,
    top: '47%',
    left: '22%',
    title: "AI Destekli Çevre Güvenliği & İzleme",
    desc: "Yapay zeka analizli, gece görüşlü ve motorlu Speed Dome kameralar ile 7/24 kesintisiz koruma.",
    icon: "📹"
  },
  {
    id: 3,
    top: '40%',
    left: '74%',
    title: "Erken Uyarı ve Yangın İhbar Sistemleri",
    desc: "Tesisinizin kalbini koruyan, saniyeler içinde müdahale sağlayan akıllı altyapı ve diafon çözümleri.",
    icon: "🚨"
  },
  {
    id: 4,
    top: '75%',
    left: '50%',
    title: "Kişisel İş Güvenliği (İSG) Donanımları",
    desc: "Sahadaki personelin hayatını koruyan standartlara uygun baret, yelek ve yaşam hattı kurulumları.",
    icon: "🦺"
  }
];

// --- SSS VERİLERİ ---
const faqData = [
  {
    soru: "Güvenlik kamerası ve altyapı kurulum süreci ne kadar sürüyor?",
    cevap: "Projenin büyüklüğüne ve saha şartlarına bağlı olarak değişmekle birlikte, standart ticari işletme kurulumları uzman ekiplerimiz tarafından genellikle 1-2 iş günü içerisinde tamamlanıp sistem aktif hale getirilmektedir."
  },
  {
    soru: "Güvenlik fileleriniz hangi standartlara ve testlere tabi tutuluyor?",
    cevap: "Tüm inşaat ve güvenlik file ağlarımız uluslararası TS EN 1263-1 standartlarına uygun olarak üretilmekte olup, kurulumları profesyonel ve yüksekte çalışma sertifikalı (İSG) ekiplerimiz tarafından milimetrik olarak yapılmaktadır."
  },
  {
    soru: "Zayıf akım ve yangın altyapısı mevcut binalara sonradan eklenebilir mi?",
    cevap: "Kesinlikle. Uzman mühendislik ekibimiz, binanızın mevcut mimari estetiğini bozmadan, en az kırma-dökme işlemiyle sıva üstü kroşe veya asma tavan içi gizli kablolama teknikleriyle kusursuz entegrasyon sağlamaktadır."
  },
  {
    soru: "Kullandığınız ürünlerde garanti ve teknik destek süresi nedir?",
    cevap: "Kurulumunu gerçekleştirdiğimiz tüm teknolojik cihazlar (kamera, alarm, switch) 2 yıl resmi distribütör garantilidir. Ayrıca Demir Grup olarak, tüm işçilik ve montaj hatalarına karşı 1 yıl boyunca ücretsiz 'Yerinde Teknik Destek' sunuyoruz."
  }
];

function Home() {
  const [aktifResim, setAktifResim] = useState(0);
  const [aktifFaq, setAktifFaq] = useState(null);

  const toggleFaq = (index) => {
    setAktifFaq(aktifFaq === index ? null : index);
  };

  const statsRef = useRef(null);
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStatsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }
    return () => {
      if (statsRef.current) observer.unobserve(statsRef.current);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50, 
    });
  }, []);

  useEffect(() => {
    const dongu = setInterval(() => {
      setAktifResim((onceki) => {
        const yeniSira = (onceki + 1) % resimler.length;
        return yeniSira;
      });
    }, 2000); 

    return () => clearInterval(dongu);
  }, []);

  return (
    <div className="page-wrapper" style={{ overflowX: 'hidden' }}>
      
      {/* --- ANA SAYFAYA ÖZEL GOOGLE TABELASI VE JSON KİMLİĞİ --- */}
      <Helmet>
        <title>Demir Grup | Ankara Güvenlik Sistemleri & İnşaat Altyapı</title>
        <meta name="description" content="Ankara'nın lider güvenlik sistemleri, AI destekli kamera, güvenlik fileleri ve zayıf akım altyapı firması. Ücretsiz keşif için tıklayın." />
        
        {/* ANA SAYFA İŞLETME JSON KARTI (GERÇEK ADRES İLE GÜNCELLENDİ) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Demir Grup İnşaat & Güvenlik Sistemleri",
            "image": "https://www.ddemirgrup.com.tr/logo.png",
            "@id": "https://www.ddemirgrup.com.tr",
            "url": "https://www.ddemirgrup.com.tr",
            "telephone": "+905454167141",
            "priceRange": "₺₺",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Malazgirt Mah. Buhara Cad. 71/C",
              "addressLocality": "Sincan",
              "addressRegion": "Ankara",
              "postalCode": "06930",
              "addressCountry": "TR"
            }
          })}
        </script>
      </Helmet>

      {/* --- 1. VİTRİN BÖLÜMÜ (HERO) --- */}
      <div className="home-container">
        <div className="background-text-container" data-aos="fade-down" data-aos-duration="1200">
          <h1 className="background-text">GÜVENLİK HİZMETLERİ</h1>
        </div>

        <div className="hero-section">
          <div className="hero-left" data-aos="fade-right">
            <h2 className="main-title">Kusursuz Güvenlik,<br/>Tam Koruma.</h2>
            <div className="hero-buttons">
              <Link to="/iletisim" className="btn-primary">Hemen Teklif Al </Link>
              <a href="#hizmetlerimiz" className="btn-secondary">Sistemleri İncele</a>
            </div>
          </div>

          <div className="hero-center" data-aos="zoom-in" data-aos-delay="100">
            <div className="slider-wrapper">
              {resimler.map((resim, index) => (
                <img 
                  key={index}
                  src={resim} 
                  alt={`Demir Grup Hizmetleri ${index}`} 
                  className={`slider-image ${index === aktifResim ? 'active' : ''}`} 
                />
              ))}
            </div>
          </div>

          <div className="hero-right" data-aos="fade-left" data-aos-delay="200">
            <div className="info-card">
              <div className="info-image video-box">
                <video 
                  src={tanitimVideo} 
                  autoPlay 
                  loop 
                  muted 
                  playsInline 
                  className="inline-video-player"
                />
              </div>
              <p>Tüm güvenlik ve altyapı sistemlerimizin projelerinizi nasıl koruduğunu keşfedin.</p>
            </div>
          </div>
        </div>
      </div>

      
      {/* --- 2. MİSYON VE VİZYON BÖLÜMÜ --- */}
      <div className="about-section">
        <div className="about-header" data-aos="zoom-in-up">
          <h2>Geleceği Güvence Altına Alıyoruz</h2>
          <p>Demir Grup İnşaat & Güvenlik Sistemleri olarak sektördeki öncü rolümüzü, insan odağına ve bitmeyen yenilik tutkumuza borçluyuz.</p>
        </div>
        
        <div className="mv-cards">
          <div data-aos="fade-right" data-aos-delay="100" style={{ flex: 1, display: 'flex' }}>
            <div className="mv-card" style={{ width: '100%' }}>
              <div className="mv-icon">🎯</div>
              <h3>Misyonumuz</h3>
              <p>Müşterilerimizin ihtiyaçlarını en doğru şekilde analiz ederek, dünya standartlarında sürdürülebilir, etik ve yenilikçi çözümler sunmak. Geniş ürün ve hizmet yelpazemizi toplumun her kesimine en hızlı şekilde ulaştırırken, mutlak müşteri memnuniyetini her şeyin üstünde tutarak üreten, yetiştiren ve geliştiren bir işletme olmak.</p>
            </div>
          </div>

          <div data-aos="fade-left" data-aos-delay="200" style={{ flex: 1, display: 'flex' }}>
            <div className="mv-card" style={{ width: '100%' }}>
              <div className="mv-icon">👁️‍🗨️</div>
              <h3>Vizyonumuz</h3>
              <p>Ankara'dan başlayarak tüm Türkiye'de güvenliğin ve altyapının standartlarını belirleyen, rakiplerinin örnek aldığı evrensel bir lider marka olmak. İnsan kaynağını en değerli varlığı kabul ederek; sadece bir işletme değil, sektörün trend belirleyicisi ve gençlerin kariyer hedeflerini süsleyen saygın bir teknoloji ortağı haline gelmek.</p>
            </div>
          </div>
        </div>

        {/* --- YENİ EKLENTİ 1: VİTRİN ALTI ACİL İLETİŞİM BANT --- */}
      <div className="quick-contact-bar-wrapper" data-aos="fade-up" data-aos-delay="300">
        <div className="quick-contact-bar">
          <p>Ücretsiz Keşif ve Projelendirme İçin Uzman Ekibimizle İletişime Geçin</p>
          <div className="quick-contact-buttons">
            <a href="tel:+905454167141" className="qc-btn qc-phone">📞 0545 416 71 41</a>
            <a href="https://wa.me/905454167141" target="_blank" rel="noreferrer" className="qc-btn qc-wp">💬 WhatsApp'tan Yazın</a>
          </div>
        </div>
      </div>

      </div>

      {/* --- 3. HİZMETLER / FAALİYET ALANLARI BÖLÜMÜ --- */}
      <div className="services-section" id="hizmetlerimiz">
        <div className="services-header" data-aos="zoom-in-up">
          <span className="subtitle">NELER YAPIYORUZ?</span>
          <h2>Geniş Hizmet Yelpazesiyle Tam Çözüm</h2>
        </div>

        <div className="services-grid">
          <div data-aos="zoom-in-up" data-aos-delay="100">
            <div className="service-item">
              <img src={serviceKamera} alt="Güvenlik Kamera Sistemleri" className="service-image" />
              <h3>Güvenlik Kamera Sistemleri</h3>
              <p>Speed Dome, IP ve Network kameralar ile 7/24 kesintisiz izleme ve kayıt çözümleri.</p>
              <ul className="service-list">
                <li>Gece Görüşlü Sistemler</li><li>Plaka Tanıma Teknolojisi</li><li>Uzaktan Mobil İzleme</li>
              </ul>
            </div>
          </div>

          <div data-aos="zoom-in-up" data-aos-delay="200">
            <div className="service-item">
              <img src={serviceFile} alt="Güvenlik File Çeşitleri" className="service-image" />
              <h3>Güvenlik File Çeşitleri</h3>
              <p>İnşaat, spor alanları ve merdiven boşlukları için yüksek mukavemetli file çözümleri.</p>
              <ul className="service-list">
                <li>İnşaat Güvenlik Fileleri</li><li>Kuş Koruma Sistemleri</li><li>Havuz & Balkon Fileleri</li>
              </ul>
            </div>
          </div>

          <div data-aos="zoom-in-up" data-aos-delay="300">
            <div className="service-item">
              <img src={serviceEkipman} alt="İş Güvenliği Ekipmanları" className="service-image" />
              <h3>İş Güvenliği Ekipmanları</h3>
              <p>Yüksekte çalışma ekipmanlarından kişisel koruyuculara kadar tam donanım.</p>
              <ul className="service-list">
                <li>Yaşam Hattı Kurulumu</li><li>Kişisel Koruyucu Donanım</li><li>Emniyet Alan Perdeleri</li>
              </ul>
            </div>
          </div>

          <div data-aos="zoom-in-up" data-aos-delay="400">
            <div className="service-item">
              <img src={serviceAkim} alt="Zayıf Akım Sistemleri" className="service-image" />
              <h3>Zayıf Akım Sistemleri</h3>
              <p>Yangın alarm, merkezi uydu ve profesyonel seslendirme altyapı projeleri.</p>
              <ul className="service-list">
                <li>Yangın İhbar Sistemleri</li><li>Görüntülü Diafon</li><li>Fiber Optik Altyapı</li>
              </ul>
            </div>
          </div>
        </div>

       {/* --- HİZMETLER ALTI BÜYÜK VIP İLETİŞİM BANDI --- */}
<div className="services-cta-banner" data-aos="zoom-in-up" data-aos-delay="200">
  <div className="cta-content">
    <h3>Projenize Özel Güvenlik Çözümleri mi Arıyorsunuz?</h3>
    <p>Mühendislerimiz tesisinizi incelesin, en uygun altyapıyı birlikte tasarlayalım.</p>
  </div>
  <div className="cta-actions">
    <Link to="/iletisim" className="cta-btn-outline">İletişim Formu</Link>
    <a href="https://wa.me/905454167141" target="_blank" rel="noreferrer" className="cta-btn-wp">Hemen WhatsApp'tan Ulaşın</a>
  </div>
</div>

      </div>

      {/* --- 4. ANALİTİK VE PERFORMANS TABLOSU --- */}
      <div className="analytics-section" ref={statsRef}>
        <div className="analytics-header" data-aos="fade-down">
          <span className="subtitle">SEKTÖR VE BİZ</span>
          <h2>Rakamlarla Demir Grup Farkı</h2>
          <p>Standart güvenlik önlemleri ile Demir Grup'un sunduğu tam kapsamlı altyapı koruması arasındaki ölçülebilir performans farkları.</p>
        </div>

        <div className="data-table-container" data-aos="zoom-in-up" data-aos-delay="200">
          <div className="data-table-header desktop-only">
            <div className="col-service">HİZMET / ÇÖZÜM</div>
            <div className="col-risk">ÖNLENEN ANA RİSK</div>
            <div className="col-avg">SEKTÖR ORTALAMASI</div>
            <div className="col-perf">DEMİR GRUP KORUMASI</div>
          </div>
          <div className="data-table-body">
            <div className="data-row">
              <div className="col-service"><span className="row-icon">📹</span><strong>Akıllı Kamera Sistemleri</strong></div>
              <div className="col-risk">İzinsiz Giriş & Kör Nokta</div>
              <div className="col-avg">%65 Standart Koruma</div>
              <div className="col-perf">
                <div className="perf-bar-bg"><div className={`perf-bar fill-92 ${statsVisible ? 'animate' : ''}`}></div></div>
                <span className="perf-score">%92</span>
              </div>
            </div>
            <div className="data-row">
              <div className="col-service"><span className="row-icon">🕸️</span><strong>Güvenlik File Ağları</strong></div>
              <div className="col-risk">Yüksekten Düşme (Ölümcül)</div>
              <div className="col-avg">%70 İptidaî Fileler</div>
              <div className="col-perf">
                <div className="perf-bar-bg"><div className={`perf-bar fill-98 ${statsVisible ? 'animate' : ''}`}></div></div>
                <span className="perf-score">%98</span>
              </div>
            </div>
            <div className="data-row">
              <div className="col-service"><span className="row-icon">🦺</span><strong>İş Güvenliği Ekipmanı</strong></div>
              <div className="col-risk">Şantiye İçi Yaralanmalar</div>
              <div className="col-avg">%60 Standart Baret/Yelek</div>
              <div className="col-perf">
                <div className="perf-bar-bg"><div className={`perf-bar fill-88 ${statsVisible ? 'animate' : ''}`}></div></div>
                <span className="perf-score">%88</span>
              </div>
            </div>
            <div className="data-row">
              <div className="col-service"><span className="row-icon">🚨</span><strong>Zayıf Akım Sistemleri</strong></div>
              <div className="col-risk">Yangın Gecikmesi & Veri Kaybı</div>
              <div className="col-avg">%55 Klasik Alarmlar</div>
              <div className="col-perf">
                <div className="perf-bar-bg"><div className={`perf-bar fill-96 ${statsVisible ? 'animate' : ''}`}></div></div>
                <span className="perf-score">%96</span>
              </div>
            </div>
          </div>
        </div>

        
      </div>

      {/* --- 5. İNTERAKTİF TESİS KROKİSİ --- */}
      <div className="interactive-map-section">
        <div className="analytics-header" data-aos="fade-down">
          <span className="subtitle">MÜHENDİSLİK ÇÖZÜMLERİMİZ</span>
          <h2>Projenizin Her Noktasındayız</h2>
          <p>Tesisinizin ve personelinizin ihtiyacı olan her türlü güvenlik altyapısını bir mühendis gibi analiz edip, kusursuzca kuruyoruz.</p>
        </div>

        <div className="map-wrapper" data-aos="zoom-in" data-aos-delay="200">
          <div style={{position: "relative"}}>
            <img src={interactiveMapImg} alt="Demir Grup Tesis Güvenlik Krokisi" className="map-bg" />
            {hotspotsData.map(spot => (
              <div key={spot.id} className="hotspot-point" style={{ top: spot.top, left: spot.left }}>
                <div className="pulse-ring"></div>
                <div className="info-card-floating">
                  <div className="card-header"><span className="card-icon">{spot.icon}</span><h3>{spot.title}</h3></div>
                  <p>{spot.desc}</p>
                  <Link to="/urunler" className="card-btn">Detaylı İncele ↗</Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        
      </div>

      {/* --- 6. SIKÇA SORULAN SORULAR --- */}
      <div className="faq-section">
        <div className="faq-layout">
          
          <div className="faq-left" data-aos="fade-right">
            <span className="subtitle">MERAK EDİLENLER</span>
            <h2>Aklınızda Soru<br/>İşareti Kalmasın</h2>
            <p>Hizmet süreçlerimiz, kalite standartlarımız ve kurulum detaylarımız hakkında en çok merak edilenleri sizin için yanıtladık.</p>
            
            <div className="faq-contact-card hide-on-mobile">
              <div className="faq-contact-icon">📞</div>
              <div>
                <h4>Cevabını Bulamadınız mı?</h4>
                <p>Uzman ekibimiz projelerinize özel tüm soruları yanıtlamak için hazır.</p>
                <Link to="/iletisim" className="faq-contact-btn">Hemen Bizi Arayın ↗</Link>
              </div>
            </div>
          </div>

          <div className="faq-right" data-aos="fade-left" data-aos-delay="200">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${aktifFaq === index ? 'active' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq-question">
                  <h3>{faq.soru}</h3>
                  <span className="faq-icon">{aktifFaq === index ? '−' : '+'}</span>
                </div>
                <div className="faq-answer">
                  <p>{faq.cevap}</p>
                </div>
              </div>
            ))}

            <div className="faq-contact-card hide-on-desktop" style={{ marginTop: '30px' }}>
              <div className="faq-contact-icon">📞</div>
              <div>
                <h4>Cevabını Bulamadınız mı?</h4>
                <p>Uzman ekibimiz projelerinize özel tüm soruları yanıtlamak için hazır.</p>
                <Link to="/iletisim" className="faq-contact-btn">Hemen Bizi Arayın ↗</Link>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}

export default Home;